import type { GetPlanCounterpartyMismatchResponse } from '@ebalance/proto/bffuser/v1/submission_management_service_pb'

/**
 * 未解消の取引相手間ミスマッチがあるか (解消ボタンの表示条件・対応メモパネルの
 * 初期の開閉の正)。取得前・機能 OFF・解消済みは false。
 */
export function hasUnresolvedMismatch(
  data:
    | Pick<
        GetPlanCounterpartyMismatchResponse,
        'featureEnabled' | 'hasUnresolved'
      >
    | undefined,
): boolean {
  return data !== undefined && data.featureEnabled && data.hasUnresolved
}

/**
 * 取引相手間ミスマッチがあり、そのすべてを解消済みにした計画か
 * (`submission-management.md` §7)。不整合の誘導メッセージ (AC-PLC-020-2) を出さない条件。
 * 解消は記録 (`resolution`) が残り、解消後に届いた通知で未解消に戻る (AC-PSM-067)。
 * 取得前・失敗・機能 OFF・一度も解消していない計画は false (誘導を出す側に倒す)。
 */
export function isCounterpartyMismatchResolved(
  data:
    | Pick<
        GetPlanCounterpartyMismatchResponse,
        'featureEnabled' | 'hasUnresolved' | 'resolution'
      >
    | undefined,
): boolean {
  return (
    data !== undefined &&
    data.featureEnabled &&
    !data.hasUnresolved &&
    data.resolution !== undefined
  )
}
